<template>
  <JSkeleton
    v-if="isFetching"
    :options="{
      type: 'rectangle',
      width: isMobile ? '100%' : '12rem',
      height: isMobile ? 46 : 32,
      borderRadius: 8,
    }"
    class="mb-16 md:mb-0"
  />

  <template v-if="!isFetching && showAffiliateButton">
    <JButton
      v-if="!isMobile"
      color="secondary"
      variant="tonal"
      @click.prevent="$emit('confirm')"
    >
      <JIcon size="16" name="gift" class="text-dark" />
      <span>{{ $t('joinAsAffiliate') }}</span>
    </JButton>

    <div
      v-if="isMobile"
      class="mb-16 text-subject text-gray-500"
      @click.prevent="$emit('confirm')"
    >
      <button class="flex w-full justify-between rounded-md p-16 shadow-md">
        <span class="text-subject text-gray-500">
          {{ $t('joinAsAffiliate') }}
        </span>
        <JIcon name="alt-arrow-right-line" class="text-gray-500" />
      </button>
    </div>
  </template>
</template>

<script lang="ts" setup>
import { JButton, JIcon, JSkeleton, useDevicePlatform } from '@journey/ui-kit'
import { useAffiliate } from '../../composables'
import type { Emits } from './AffiliateButton.types'

defineEmits<Emits>()

const { isMobile } = useDevicePlatform()

const { isFetching, showAffiliateButton } = useAffiliate()
</script>
